const getters = {
  getActiveCampaigns: (state) => state.activeCampaigns,
  getExpiredCampaigns: (state) => state.expiredCampaigns,
  getCampaign: (state) => state.campaign,
  getChannelData: (state) => state.channelData,
  getCategories: (state) => state.categories,
  getPromotionCodes: (state) => state.promotionCodes,
  getPrefixPromotion: (state) => state.prefixPromotion,
  getCampaignCombinations: (state) => state.campaignCombinations,
  getDateRange: (state) => state.dateRange,
  getOrderBy: (state) => state.orderBy,
  getProductType: (state) => state.productType,
  getActiveTab: (state) => state.activeTab,
  getSearchInput: (state) => state.searchInput,
  getRuleEngineOption: (state) => state.ruleEngineOption,
};

export default getters;
